import { call, put, takeEvery } from 'redux-saga/effects'
import { ORGANIZATIONS_UPLOAD_LOGO_REQUEST } from '../actionTypes'
import { change } from 'redux-form/immutable'
import { disableOrganizationsForm, enableOrganizationsForm } from '../actions'
// @ts-ignore
import { promisedCanvasToBlob } from 'helpers/promises/promisedCanvasToBlob'
// @ts-ignore
import { showError } from 'store/entities/toastr/utils'
// @ts-ignore
import { ORGANIZATIONS_EDIT_FORM_NAME } from 'app/constants/organizations'
import { uploadFileToS3 } from 'store/entities/api/sagas/s3PolicySagas'

export default function* uploadOrganizationLogoSaga() {
  yield takeEvery(ORGANIZATIONS_UPLOAD_LOGO_REQUEST, handleUploadOrganizationLogoRequest)
}

export function* handleUploadOrganizationLogoRequest({ payload }: any) {
  try {
    yield put(disableOrganizationsForm())
    const formName = ORGANIZATIONS_EDIT_FORM_NAME
    const { file, ext, mime, fieldName } = payload
    let logoPath
    if (file instanceof HTMLCanvasElement) {
      const blob = yield call(promisedCanvasToBlob, file, mime)
      logoPath = yield call(uploadLogoToS3, blob, ext)
    } else {
      logoPath = yield call(uploadLogoToS3, file, file.name.substring(file.name.lastIndexOf('.') + 1))
    }
    yield put(change(formName, fieldName, logoPath))
  } catch (badResponse) {
    showError()
  } finally {
    yield put(enableOrganizationsForm())
  }
}

export function* uploadLogoToS3(file: any, ext: string) {
  return yield call(uploadFileToS3, { file, ext, entity: 'organizations' })
}
